import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Switch } from '../ui/switch';
import { Input } from '../ui/input';

export const ManageClientsDialog = ({ open, onOpenChange, rows, available, onToggle }) => {
  const [q, setQ] = useState('');
  const all = [...rows.map((r) => ({ id: r.clientId, name: r.clientName, on: true })), ...available.map((c) => ({ ...c, on: false }))]
    .filter((c) => (c.name || '').toLowerCase().includes(q.toLowerCase()))
    .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="bk-manage-dialog">
        <DialogHeader><DialogTitle>Clients on bookkeeping</DialogTitle></DialogHeader>
        <p className="text-sm text-stone-500 -mt-2">Switch on the clients whose books you close every month.</p>
        <Input placeholder="Search clients" value={q} onChange={(e) => setQ(e.target.value)} data-testid="bk-manage-search"/>
        <div className="max-h-80 overflow-y-auto divide-y divide-stone-100 border border-stone-200 rounded-lg">
          {all.map((c) => (
            <label key={c.id} className="flex items-center justify-between px-3 py-2.5 text-sm cursor-pointer hover:bg-stone-50">
              <span>{c.name}</span>
              <Switch checked={c.on} onCheckedChange={(v) => onToggle(c.id, v)} data-testid={`bk-toggle-${c.id}`}/>
            </label>
          ))}
          {all.length === 0 && <div className="p-4 text-sm text-stone-500 text-center">No clients found.</div>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
